import { IconType } from "react-icons";
import { FaShieldAlt, FaMicrochip, FaCogs } from "react-icons/fa"; // أيقونات صناعية وتقنية

interface FeatureType {
    icon: IconType;
    title: {
        ar: string;
        en: string;
    };
    content: {
        ar: string;
        en: string;
    };
}

export const features: FeatureType[] = [
    {
        icon: FaMicrochip, // تعبيراً عن التكنولوجيا والـ CNC
        title: {
            ar: "الدقة والتكنولوجيا",
            en: "Precision & Technology",
        },
        content: {
            ar: "نعتمد على أحدث أنظمة التحكم الرقمي CNC وتقنيات الليزر لضمان تنفيذ أدق التفاصيل الهندسية في المشغولات المعدنية.",
            en: "We rely on the latest CNC control systems and laser technologies to ensure the execution of the finest engineering details in metalwork.",
        },
    },
    {
        icon: FaShieldAlt, // تعبيراً عن المتانة والقوة (قلاع الحديد)
        title: {
            ar: "الجودة والمتانة",
            en: "Quality & Durability",
        },
        content: {
            ar: "نلتزم باستخدام أجود أنواع المعادن الخام وتطبيق معايير صارمة في التصنيع لضمان منتجات قوية تدوم طويلاً وتتحمل أقسى الظروف.",
            en: "We are committed to using the finest raw metals and applying strict manufacturing standards to ensure durable products that withstand the toughest conditions.",
        },
    },
    {
        icon: FaCogs, // تعبيراً عن الخبرة الصناعية
        title: {
            ar: "الاحترافية في التنفيذ",
            en: "Professional Execution",
        },
        content: {
            ar: "نمتلك خبرة واسعة في إدارة المشاريع الصناعية المعقدة، مع الالتزام التام بالجداول الزمنية والمواصفات الفنية المطلوبة من عملائنا.",
            en: "We possess extensive experience in managing complex industrial projects, with full commitment to timelines and technical specifications required by our clients.",
        },
    },
];